import React from 'react'
import withStyles from 'constructicon/with-styles'
import styles from './styles'

import Image from 'constructicon/image'

const ProfilePicture = ({
  defaultImage = {},
  fundraisingPage,
  styles
}) => (
  <Image
    alt={fundraisingPage.name}
    src={fundraisingPage.image || defaultImage.url}
    styles={styles.image}
  />
)

export default withStyles(styles)(ProfilePicture)
